export const fetchEmployers = async () => {
  const page = 1;
  const pageSize = 5;
  try {
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}/main/list/public-employers?page=${page}&number_of_employers=${pageSize}`,
      {
        method: "GET",
      }
    );
    if (!res.ok) {
      throw new Error("Something went wrong in fetching employers");
    }
    const data = await res.json();
    return data;
  } catch (err) {
    console.error("There was a problem with the fetch employers", err);
    throw err;
  }
};
